import { Button } from "@shared/ui/button";
import { Home, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

interface AddressInformationReviewProps {
  data?: any;
  onEdit?: () => void;
}

export function AddressInformationReview({
  data,
  onEdit,
}: AddressInformationReviewProps) {
  const { t } = useTranslation();
  const serviceAddress = data?.service_address;
  const mailingAddress = data?.same_as_service_address
    ? data?.service_address
    : data?.mailing_address;

  const hasServiceAddress =
    serviceAddress &&
    (serviceAddress.house_unit_number ||
      serviceAddress.street_address ||
      serviceAddress.city ||
      serviceAddress.zip_postal_code);

  const hasMailingAddress =
    mailingAddress &&
    (mailingAddress.house_unit_number ||
      mailingAddress.street_address ||
      mailingAddress.city ||
      mailingAddress.zip_postal_code);

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">
          {t("Address Information")}
        </h2>
        <Button variant="outline" size="sm" onClick={onEdit}>
          Edit
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Service Address */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Home className="h-5 w-5 text-blue-600" />
            <h3 className="text-base font-semibold text-gray-900">
              {t("Service Address")}
            </h3>
          </div>
          {hasServiceAddress ? (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm text-gray-900">
                {serviceAddress.house_unit_number}
              </p>
              <p className="text-sm text-gray-900">
                {serviceAddress.street_address}
              </p>
             <p className="text-sm text-gray-900">
  {serviceAddress.city_display || serviceAddress.city}
  {serviceAddress.zip_postal_code &&
    `, ${serviceAddress.zip_postal_code}`}
</p>
            </div>
          ) : (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm text-gray-600 italic">
                {t("No service address provided")}
              </p>
            </div>
          )}
        </div>

        {/* Mailing Address */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <FileText className="h-5 w-5 text-green-600" />
            <h3 className="text-base font-semibold text-gray-900">
              {t("Mailing Address")}
            </h3>
          </div>
          {hasMailingAddress ? (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <p className="text-sm text-gray-900">
                {mailingAddress.house_unit_number}
              </p>
              <p className="text-sm text-gray-900">
                {mailingAddress.street_address}
              </p>
           <p className="text-sm text-gray-900">
  {mailingAddress.city_display || mailingAddress.city}
  {mailingAddress.zip_postal_code &&
    `, ${mailingAddress.zip_postal_code}`}
</p>
            </div>
          ) : (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <p className="text-sm text-gray-600 italic">
                {t("No address provided")}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}